import type { LotteryPackSnapshot } from '../../../types/services/lotteryPacks';

export const isBackstockInventoryPack = (pack: LotteryPackSnapshot): boolean => (
  pack.location_type?.toLowerCase() === 'backstock'
  && !pack.is_sold_out
  && !pack.is_excluded_from_tracking
  && (pack.tickets_remaining === null || pack.tickets_remaining > 0)
);

export const isFullBackstockPack = (pack: LotteryPackSnapshot): boolean => (
  pack.tickets_per_pack !== null
  && pack.tickets_remaining !== null
  && pack.tickets_remaining >= pack.tickets_per_pack
);

export const getBackstockSimulatorTicketNumber = (pack: LotteryPackSnapshot): number | null => {
  if (pack.tickets_per_pack !== null && isFullBackstockPack(pack)) {
    return Math.max(0, pack.tickets_per_pack - 1);
  }

  if (pack.latest_audit_ticket_number !== null) {
    return pack.latest_audit_ticket_number;
  }

  if (pack.ending_ticket_number !== null) {
    return pack.ending_ticket_number;
  }

  return pack.tickets_per_pack === null ? null : Math.max(0, pack.tickets_per_pack - 1);
};
